module.exports = __webpack_public_path__ + "static/band-thom-d84f664d87476b6e470933723bc69ab1.jpg";